import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PngoDealershipService} from "../../utils/data-services/pngo-dealership.service";

@Component({
  selector: 'app-configuration-soft-net',
  templateUrl: './configuration-soft-net.component.html',
  styleUrls: ['./configuration-soft-net.component.scss']
})
export class ConfigurationSoftNetComponent implements OnInit {
  dealershipId = 0;
  softnetConfiguration = null;
  constructor(private activeRoute: ActivatedRoute, private route: Router, private pngoDealershipService: PngoDealershipService) { }

  ngOnInit() {
    this.dealershipId = Number(this.activeRoute.snapshot.paramMap.get('dealershipId'));
    this.getSoftnetConfiguration();
  }
  getSoftnetConfiguration(): void {
    this.pngoDealershipService.getSoftNetInformations(this.dealershipId).subscribe(result => {
      this.softnetConfiguration = result;
      console.log(this.softnetConfiguration);
    });
  }

  onCancelClick(): void {
    this.route.navigate(['../gestion-mapping-planngo']);
  }
  getDayOfTheWeek(day: number): string {
    const days = [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ];
    return days[day];
  }
  getDayAbvOfTheWeek(day: number): string {
    const days = [
      'dim.',
      'lun.',
      'mar.',
      'mer.',
      'jeu.',
      'ven.',
      'sam.',
    ];
    return days[day];
  }
}
